import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.5 9h5m-2.5 0v6","key":"svg-0"}],["path",{"d":"M13 15v-6l3 4l3 -4v6","key":"svg-1"}]]

const IconTrademark = createReactComponent('outline', 'trademark', 'Trademark', __iconNode);

export default IconTrademark;